module.exports = __webpack_public_path__ + "img/agency-personalized-landing.0af3592e.svg";